module.exports = __webpack_public_path__ + "7ddeec4b2732ceae86332b4025e0c54f.png";